import { render, staticRenderFns } from "./PresaleResults.vue?vue&type=template&id=2e7eeb3e"
import script from "./PresaleResults.vue?vue&type=script&lang=js"
export * from "./PresaleResults.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports